import { render, staticRenderFns } from "./ImportantDates.vue?vue&type=template&id=6c4bee7e&scoped=true&"
import script from "./ImportantDates.vue?vue&type=script&lang=js&"
export * from "./ImportantDates.vue?vue&type=script&lang=js&"
import style0 from "./ImportantDates.vue?vue&type=style&index=0&id=6c4bee7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4bee7e",
  null
  
)

export default component.exports